<template>
    <div
        class="betBuilderRecommendation"
        v-bind:class="{ live: event.isLive }"
    >
        <div class="header">
            <SboIcon
                v-bind:size="14"
                name="system:fire"
                left
            />
            <div class="name">
                {{ title }}
            </div>
        </div>
        <div class="content">
            <div class="betBuilderCombinations">
                <div class="betBuilderCombinations-content">
                    <div
                        v-for="(combination, index) in visibleCombinations"
                        v-bind:key="combination.combinationKey"
                        class="betBuilderCombinations-item"
                    >
                        <BetBuilderCombination
                            v-bind:combination="combination"
                            v-bind:event="event"
                            v-bind:order="index + 1"
                            v-on:deleted="combinationDeleted"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, reactive } from 'vue';
    import BetBuilderCombination from '@/components/betBuilderRecommendation/BetBuilderCombination.vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import { i18n } from '@/core/lib/i18n';
    import type { IEvent } from '@/interface/IEvent';
    import type { IBetBuilderCombination } from '@/interface/betBuilder';

    const props = defineProps<{
        event: IEvent;
        combinations: IBetBuilderCombination[];
    }>();

    const title = computed(() => i18n.t('popular_bet_builder_card_title'));

    const deletedKeys = reactive(new Set<string>());
    const visibleCombinations = computed(() => props.combinations.filter(c => !deletedKeys.has(c.combinationKey)));

    function combinationDeleted(combinationKey: string) {
        deletedKeys.add(combinationKey);
    }
</script>

<style lang="scss" scoped>
    @import "@/components/mpRecommendation/MpRecommendation";
    @import "@/components/betBuilderRecommendation/BetBuilderRecommendation";
</style>
